import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import SyncMonitoringDashboard from './views/SyncMonitoringDashboard';

export const syncMonitoringRoutes: RouteObject[] = [
    {
        path: '/admin/payment-settings/sync-monitoring',
        element: <SyncMonitoringDashboard />,
        errorElement: <ErrorBoundary />,
    },
];
